import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card } from 'react-bootstrap';

import PagesHeroSection from '../../components/pagesHeroSection/pagesHeroSection';
import SEOUpdater from '../../utils/hoc/SEOUpdater';
import './legalDisclaimer.scss';

const LegalDisclaimer = () => {
  const { t } = useTranslation('legalDisclaimer');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = [
    'noAttorneyClient',
    'generalInfo',
    'noGuarantee',
    'jurisdiction',
    'advertising',
    'thirdParty',
    'useAtRisk',
    'contact',
  ];

  return (
    <div className="legal-disclaimer">
      {/* Dynamic SEO metadata */}
      <SEOUpdater page="legalDisclaimer" />

      {/* Hero Section */}
      <PagesHeroSection page={t('title')} />

      <Container>
        {/* Effective Date */}
        <Row className="mb-5">
          <Col>
            <p className="text-center text-muted mt-3">{t('effectiveDate')}</p>
          </Col>
        </Row>

        {/* Disclaimer Sections */}
        <Row>
          <Col md={10} lg={8} className="mx-auto">
            {sections.map((key, index) => (
              <Card key={index} className="mb-4 shadow-sm">
                <Card.Body>
                  <Card.Title>{t(`${key}.title`)}</Card.Title>
                  <Card.Text>
                    {t(`${key}.text1`)}

                    {t(`${key}.text2`, '') && (
                      <>
                        <br />
                        <strong>{t(`${key}.text2`)}</strong>
                      </>
                    )}

                    {[3, 4, 5].map(n => {
                      const text = t(`${key}.text${n}`, '');
                      return (
                        text && (
                          <React.Fragment key={n}>
                            <br />
                            {text}
                          </React.Fragment>
                        )
                      );
                    })}
                  </Card.Text>
                </Card.Body>
              </Card>
            ))}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LegalDisclaimer;
